(() => {

    // =========================== Start of Header =========================== //

    // Header indicator position state
    const headerRef = document.querySelector(".header");
    const navTogglerRef = headerRef.querySelector(".navToggler");

    // Open-Close Mobile Nav state
    let mobileNavOpen = false;
    const html = document.documentElement;
    const toggleMobileNav = () => {
      mobileNavOpen = !mobileNavOpen;
      if (mobileNavOpen) {
        headerRef.classList.add("navOpen");
      } else {
        headerRef.classList.remove("navOpen");
      }
    };
    navTogglerRef.addEventListener("click", toggleMobileNav);

})();
